const STORAGE_KEY = "promoSimulator_persist_v1";

function safeParse(raw) {
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

/**
 * Hydrates promo simulator slice fields from localStorage (browser only).
 */
export function loadPromoSimulatorPersisted() {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = safeParse(raw);
    if (!data || typeof data !== "object") return null;
    return {
      scenarios: Array.isArray(data.scenarios) ? data.scenarios : [],
      activeScenarioId:
        data.activeScenarioId === null || typeof data.activeScenarioId === "string"
          ? data.activeScenarioId
          : null,
      selectedSKUs: Array.isArray(data.selectedSKUs) ? data.selectedSKUs : [],
      selectedWeekStart:
        data.selectedWeekStart === null || typeof data.selectedWeekStart === "number"
          ? data.selectedWeekStart
          : null,
      selectedWeekEnd:
        data.selectedWeekEnd === null || typeof data.selectedWeekEnd === "number"
          ? data.selectedWeekEnd
          : null,
      discountPct:
        typeof data.discountPct === "number" && Number.isFinite(data.discountPct)
          ? data.discountPct
          : null,
      selectedManufacturer:
        typeof data.selectedManufacturer === "string" &&
        data.selectedManufacturer.trim()
          ? data.selectedManufacturer.trim()
          : null,
      selectedClass:
        typeof data.selectedClass === "string" && data.selectedClass.trim()
          ? data.selectedClass.trim()
          : null,
    };
  } catch {
    return null;
  }
}

export function persistPromoSimulatorSlice(sliceState) {
  if (typeof window === "undefined") return;
  try {
    const payload = {
      scenarios: sliceState.scenarios,
      activeScenarioId: sliceState.activeScenarioId,
      selectedSKUs: sliceState.selectedSKUs,
      selectedWeekStart: sliceState.selectedWeekStart,
      selectedWeekEnd: sliceState.selectedWeekEnd,
      discountPct: sliceState.discountPct,
      selectedManufacturer: sliceState.selectedManufacturer,
      selectedClass: sliceState.selectedClass,
    };
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    /* quota / private mode */
  }
}
